import { render, staticRenderFns } from "./Conference.vue?vue&type=template&id=81fcecf2&"
import script from "./Conference.vue?vue&type=script&lang=ts&"
export * from "./Conference.vue?vue&type=script&lang=ts&"
import style0 from "./Conference.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports